
export enum RangeType {
    GREATER = ">",
    GREATEREQUAL = ">=",
    EQUAL = "==",
    LESS = "<",
    LESSEQUAL = "<=",
    RANGE = "Range",
    NONE = "",
    CHANGES = "Changes",
    ISON =  "IsOn",
    ISOFF= "IsOff"
}